<template>
  <v-container fluid class="bg_dark">
    <v-row no-gutters class="py-3">
      <v-col cols="12" sm="3" md="2" offset-sm="1" order="first" class="pt-4">
        <h1 class="text-h5 font-weight-light">Select action:</h1>
        <v-radio-group v-model="formType" color="dw_green">
          <v-radio color="dw_green" label="Add Tool" value="form-1" />
          <v-radio color="dw_green" label="Add Tag" value="form-2" />
          <v-radio color="dw_green" label="Add Objective" value="form-3" />
          <v-radio color="dw_green" label="Create a New Play" value="form-4" />
          <v-radio color="dw_green" label="Update an Existing Play" value="form-5" />
          <div v-if="permissions.moderator(groups) || permissions.admin(groups)">
            <v-divider class="mt-2 mb-4" style="width: 80%;"></v-divider>
            <v-radio
              color="dw_green"
              label="Playbook Review"
              value="form-6" />
          </div>
          <div v-if="permissions.admin(groups)">
            <v-divider class="my-4" style="width: 80%;"></v-divider>
            <v-radio
              color="dw_green"
              label="Remove Content"
              value="form-7" />
            <v-radio
              color="dw_green"
              label="User Management"
              value="form-8" />
          </div>
        </v-radio-group>
      </v-col>
      <v-col order="last" cols="12" sm="8" md="9">
        <component v-show="formType != ''" :is="formType" />
      </v-col>
    </v-row>
    <crud-message-snackbar />
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import crudMessageSnackbar from '@/components/notifications/crudMessageSnackbar.vue';
import addTag from '@/components/forms/addTag.vue';
import addTool from '@/components/forms/addTool.vue';
import addObjective from '@/components/forms/addObjective.vue';
import addPlay from '@/components/forms/addPlay.vue';
import editPlay from '@/components/forms/editPlay.vue';
import moderatorReview from '@/components/forms/moderatorReview.vue';
import archiveContent from '@/components/forms/archiveContent.vue';
import userManagement from '@/components/forms/userManagement.vue';

export default {
  name: 'updatePlaybook',
  components: {
    crudMessageSnackbar,
    'form-1': addTool,
    'form-2': addTag,
    'form-3': addObjective,
    'form-4': addPlay,
    'form-5': editPlay,
    'form-6': moderatorReview,
    'form-7': archiveContent,
    'form-8': userManagement
  },
  inject: ['permissions'],
  data() {
    return {
      formType: ''
    };
  },
  computed: {
    ...mapGetters([
      'groups'
    ])
  },
  mounted() {
    if (this.permissions.admin(this.groups)) this.fetchUsers();
  },
  methods: {
    ...mapActions([
      'fetchPending',
      'fetchUsers'
    ])
  }
};
</script>
